import strings from '../../Localization/Localization';

import {
  getAlphalinkOffers,
  getAlphalinkOptionOffers
} from '../../API/AlphalinkMVNO'


import {
  fetchAlphalinkMobileProductGroups
} from '../../API/AlphalinkMobileProductGroups';

let name = {
  fieldKey: "name",
  type: "text",
  label: strings.form.alphalinkMobileProduct.name.label,
  validators: []
}

let alphalinkMobileProductGroup = {
  fieldKey: "alphalink_mobile_product_group",
  label: strings.form.alphalinkMobileProduct.alphalinkMobileProductGroup.label,
  type: "dropdownEntity",

  validators: [],

  showEmpty: true,
  loader: {
    id: "alphalinkMobileProductGroups",
    loader: fetchAlphalinkMobileProductGroups,
    loaderRequire: () => true,
    loaderArguments: () => [],
  },

  adapter: {
    requirement: (data) => data["id"] && data["name"],
    getValue: (data) => data["id"],
    getLabel: (data) => data["name"],
  },
}

let alphalinkOffer = {
  fieldKey: "alphalink_offer",
  type: "dropdown",
  label: strings.form.alphalinkMobileProduct.alphalinkOffer.label,
  validators: [],

  showEmpty: true,
  input: 'formValues',
  compute: (getValues, extraValues) => {
    let values = getValues();

    if(!values["alphalink_mobile_product_group"]) {
      return [];
    }

    if(extraValues.alphalinkOffers["request_status"] === 200) {
      return extraValues.alphalinkOffers.result.data
        .filter((alphalinkOffer) => {
          if(alphalinkOffer["idoffer_parent"] === values["alphalink_mobile_product_group"]["alphalink_product_offer_parent_id"]) {
            return true;
          }
          return false;
        })
        .map((alphalinkOffer) => {
          return {
            value: alphalinkOffer["reference"],
            label: alphalinkOffer["retailer_repackaging"]
          };
        }
      );
    }

    return []
  }
}

let alphalinkOptionEsim = {
  fieldKey: "alphalink_option_esim",
  type: "dropdown",
  label: strings.form.alphalinkMobileProduct.alphalinkOptionEsim.label,
  validators: [],

  events: [
    {
      id: "resetOptionEsim",
      event: "onChange",
      target: "alphalink_offer",
      function: (component) => {
        component.onChange(null)
      }
    }
  ],

  showEmpty: true,
  input: 'formValues',
  compute: (getValues, extraValues) => {
    let options = [];

    if(extraValues.alphalinkOptionOffers["request_status"] === 200 && Array.isArray(extraValues.alphalinkOptionOffers.result.data)) {
      extraValues.alphalinkOptionOffers.result.data.forEach((alphalinkOptionOffer) => {
        alphalinkOptionOffer.value.forEach((value) => {
          if(value["offer"] && value["offer"].match(/eSIM/gi)) {
            options.push({
              value: value["reference"],
              label: value["offer"]
            });
          }
        });
      });
    }

    return options;
  }
}

let alphalinkOptionPortability = {
  fieldKey: "alphalink_option_portability",
  type: "dropdown",
  label: strings.form.alphalinkMobileProduct.alphalinkOptionPortability.label,
  validators: [],

  events: [
    {
      id: "resetOptionPortability",
      event: "onChange",
      target: "alphalink_offer",
      function: (component) => {
        component.onChange(null)
      }
    }
  ],

  showEmpty: true,
  input: 'formValues',
  compute: (getValues, extraValues) => {
    let options = [];

    if(extraValues.alphalinkOptionOffers["request_status"] === 200 && Array.isArray(extraValues.alphalinkOptionOffers.result.data)) {
      extraValues.alphalinkOptionOffers.result.data.forEach((alphalinkOptionOffer) => {
        alphalinkOptionOffer.value.forEach((value) => {
          if(value["offer"] && value["offer"].match(/Porta/gi)) {
            options.push({
              value: value["reference"],
              label: value["offer"]
            });
          }
        });
      });
    }

    return options;
  }
}

let alphalinkOptions = {
  fieldKey: "alphalink_options_object",
  type: 'configurableField',
  label: "",
  validators: [],

  events: [
    {
      id: "resetOptions",
      event: "onChange",
      target: "alphalink_offer",
      function: (component) => {
        component.onChange(null)
      }
    }
  ],

  subField: (value, getValues, getExtraValues) => {
    let extraValues = getExtraValues();

    let fields = [];

    if(extraValues.alphalinkOptionOffers["request_status"] === 200 && Array.isArray(extraValues.alphalinkOptionOffers.result.data)) {
      extraValues.alphalinkOptionOffers.result.data.forEach((alphalinkOptionOffer, i) => {
        let field = {
          fieldKey: `alphalink_option-${alphalinkOptionOffer["idproduct_characteristic_order"]}`,
          type: (alphalinkOptionOffer["idcharacteristic_control"] === 8)?"dropdownMulti":"dropdown",
          label: alphalinkOptionOffer["characteristic_order_display"],
          validators: [],

          showEmpty: true,
          options: []
        }
        let valid = false;
        alphalinkOptionOffer.value.every((value) => {
          if(value["offer"] && (value["offer"].match(/Porta/gi) || value["offer"].match(/eSIM/gi))) {
            valid = false;
            return false;
          }
          else if(value.reference) {
            valid = true;
            field.options.push({
              value: value.reference,
              label: value.offer
            });
          }
          return true;
        });

        if(valid) {
          fields.push(field);
        }
      });
    }

    return {
      subForm: {
        formKey: "alphalink_options",
        fields: fields
      }
    }
  },
  subFieldConf: {
    label: (value) => strings.form.alphalinkMobileProduct.alphalinkOptions.label,
    type: (value) => 'subform',
    disabled: () => false,
    validators: (value) => []
  },
}

let alphalinkOptions_Display = {
  fieldKey: "alphalink_options",
  type: 'array',
  label: strings.form.alphalinkMobileProduct.alphalinkOptions.label_Display,
  validators: [],

  defaultNumberOfField: 0,
  allowMoreField: true,

  allowMoreFieldAddLabel: strings.form.alphalinkMobileProduct.alphalinkOptions.allowMoreField.addLabel,
  allowMoreFieldRemoveLabel: strings.form.alphalinkMobileProduct.alphalinkOptions.allowMoreField.removeLabel,
  allowMoreFieldRemovingLabel: strings.form.alphalinkMobileProduct.alphalinkOptions.allowMoreField.removingLabel,

  subField: {
    type: "text",
    label: strings.form.alphalinkMobileProduct.alphalinkOptions.label,
    validators: []
  }
}

export const form = {
  formKey: "alphalinkMobileProduct",
  fields: [
    name,
    alphalinkMobileProductGroup,
    alphalinkOffer,
    alphalinkOptionEsim,
    alphalinkOptionPortability,
    alphalinkOptions,
    alphalinkOptions_Display
  ],
  extraValues: {
    alphalinkOffers: {
      type: "load",
      loader: {
        loader: getAlphalinkOffers,
        loaderRequire: () => true,
        loaderArguments: () => [],
      }
    },
    alphalinkOptionOffers: {
      type: "load",
      loader: {
        loader: getAlphalinkOptionOffers,
        loaderRequire: (values) => {
          if(values["alphalink_offer"] && values["alphalink_offer"].length > 5) {
            return true;
          }
          return false;
        },
        reload: (values, previousValues) => {
          return values["alphalink_offer"] !== previousValues["alphalink_offer"];
        },
        loaderArguments: (values) => {
          return [values["alphalink_offer"]];
        },
        onLoaded: (values, getExtraValues, onChangeField) => {
          let alphalinkOptionsObject = {};
          let alphalinkOptionOffers = getExtraValues().alphalinkOptionOffers.result.data

          if(!!values["alphalink_options"] && Array.isArray(alphalinkOptionOffers)) values["alphalink_options"].forEach((alphalinkOption, i) => {
            alphalinkOptionOffers.forEach((alphalinkOptionOffer, i) => {
              // `alphalink_option-${alphalinkOptionOffer["idproduct_characteristic_order"]}`
              alphalinkOptionOffer.value.forEach((value, i) => {
                if(value.reference === alphalinkOption) {
                  let fieldKey = `alphalink_option-${alphalinkOptionOffer["idproduct_characteristic_order"]}`
                  if(alphalinkOptionOffer["idcharacteristic_control"] === 8) {
                    if(!alphalinkOptionsObject[fieldKey]) {
                      alphalinkOptionsObject[fieldKey] = [];
                    }
                    alphalinkOptionsObject[fieldKey].push(value.reference)
                  }
                  else {
                    alphalinkOptionsObject[fieldKey] = value.reference
                  }
                }
              });
            });
          });
          onChangeField("alphalink_options_object", alphalinkOptionsObject)
        }
      }
    }
  }
}
